module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('el-row', {
    staticClass: "headTop"
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.addType == 1 ? '添加菜单' : '修改菜单',
      "visible": _vm.dialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formparams",
    attrs: {
      "model": _vm.formparams,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "菜单名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入菜单名称"
    },
    model: {
      value: (_vm.formparams.title),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "title", $$v)
      },
      expression: "formparams.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跳转地址"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入跳转地址path"
    },
    model: {
      value: (_vm.formparams.path),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "path", $$v)
      },
      expression: "formparams.path"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组件名"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入组件名component"
    },
    model: {
      value: (_vm.formparams.component),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "component", $$v)
      },
      expression: "formparams.component"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "路由名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入路由名称name"
    },
    model: {
      value: (_vm.formparams.name),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "name", $$v)
      },
      expression: "formparams.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图标"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入icon名"
    },
    model: {
      value: (_vm.formparams.icon),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "icon", $$v)
      },
      expression: "formparams.icon"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "父级菜单"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入id"
    },
    model: {
      value: (_vm.formparams.pid),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "pid", $$v)
      },
      expression: "formparams.pid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "初始隐藏"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formparams.hidden),
      callback: function($$v) {
        _vm.$set(_vm.formparams, "hidden", $$v)
      },
      expression: "formparams.hidden"
    }
  }, _vm._l((this.showHidenList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('formparams')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('formparams')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "tableList"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData,
      "height": "73vh",
      "row-key": "id",
      "border": "",
      "lazy": "",
      "default-expand-all": "",
      "tree-props": {
        children: 'children'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "菜单名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "path",
      "label": "跳转地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "component",
      "label": "组件名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "路由名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icon",
      "label": "图标"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hidden",
      "label": "初始隐藏"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "400",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.showDialog(scope.row)
            }
          }
        }, [_vm._v("增加子菜单")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.removeList(scope.row.id)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-380910de"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/rootAdmin/rootmenuList.vue
// module id = 598
// module chunks = 70